import {SOPutPerson} from '../../core/person/so-put-person';
import {PersonCore} from './person.core';
import {SOGetPerson} from '../../core/person/so-get-person';
import {FormField, SelectionOption} from 'lionheartland';
import {putPersonFormFieldOptions} from './put-person-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {UserCore} from '../user/user.core';
import {SOGetUser} from '../../core/user/so-get-user';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutPerson extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putPersonFormFieldOptions);

  RequestClass = SOPutPerson

  constructor(
    public entityCore: PersonCore
  ) {
    super();
    if (putPersonFormFieldOptions.user) {
      putPersonFormFieldOptions.user.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('relation'),
      this.getFormValueFromIdentifier(
        'user',
        SOGetUser,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}